import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { media, Text, Heading, ArrowRightIcon } from '@elseu/sdu-titan';
import { useRef, useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Link } from '../Link/Link.js';

var QuickLinkContainer = styled.li.attrs({
  'data-test-id': 'quicklink'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n\n  ", "\n\n  border-radius: ", ";\n  width: 100%;\n  display: block;\n  margin-bottom: ", ";\n\n  ", "\n"], ["\n  background-color: ", ";\n\n  ", "\n\n  border-radius: ", ";\n  width: 100%;\n  display: block;\n  margin-bottom: ", ";\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    background = _a.background;
  return background === 'white' ? theme.designTokens.colors.secondary10 : theme.designTokens.colors.grey0;
}, function (_a) {
  var background = _a.background;
  return background === 'sand' && 'box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);';
}, function (_a) {
  var theme = _a.theme;
  return theme.borderRadius[2];
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
}, media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 0;\n  "], ["\n    margin-bottom: 0;\n  "]))));
var Content = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  ", "\n"], ["\n  padding: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[6];
}, media.greaterThan('s')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: column;\n    align-items: start;\n\n    & > :last-child {\n      margin-top: auto;\n      text-align: right;\n      align-self: flex-end;\n    }\n  "], ["\n    flex-direction: column;\n    align-items: start;\n\n    & > :last-child {\n      margin-top: auto;\n      text-align: right;\n      align-self: flex-end;\n    }\n  "]))));
var StyledLink = styled(Link)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n  display: block;\n  height: 100%;\n\n  svg {\n    transition: margin-right 0.3s ease;\n  }\n\n  &:hover,\n  &:focus {\n    text-decoration: underline;\n\n    svg {\n      margin-right: -4px;\n    }\n  }\n"], ["\n  color: ", ";\n  text-decoration: none;\n  display: block;\n  height: 100%;\n\n  svg {\n    transition: margin-right 0.3s ease;\n  }\n\n  &:hover,\n  &:focus {\n    text-decoration: underline;\n\n    svg {\n      margin-right: -4px;\n    }\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.designTokens.colors.primary80;
});
var QuickLinkText = styled(Text)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var headingLines = _a.headingLines;
  return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: none;\n\n    ", "\n  "], ["\n    display: none;\n\n    ", "\n  "])), media.greaterThan('s')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "], ["\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "])), headingLines === 2 ? 3 : 4));
});
var StyledHeading = styled(Heading)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
/**
 * The QuickLink component.
 */
var QuickLink = function (_a) {
  var title = _a.title,
    description = _a.description,
    href = _a.href,
    background = _a.background;
  var headingRef = useRef(null);
  var _b = useState(1),
    headingLines = _b[0],
    setHeadingLines = _b[1];
  /**
   * Calculate the number of lines the heading has so we can set the correct number of lines for the description.
   */
  useEffect(function () {
    if (headingRef.current) {
      var lineHeight = parseInt(window.getComputedStyle(headingRef.current).lineHeight);
      var actualHeight = headingRef.current.clientHeight;
      setHeadingLines(Math.round(actualHeight / lineHeight));
    }
  }, [title]);
  return jsx(QuickLinkContainer, {
    background: background,
    children: jsx(StyledLink, {
      to: href,
      children: jsxs(Content, {
        children: [title && jsx(StyledHeading, {
          ref: headingRef,
          heading: "h4",
          renderAs: "h3",
          children: title
        }), description && jsx(QuickLinkText, {
          as: "p",
          type: "paragraphSmall",
          headingLines: headingLines,
          children: description
        }), jsx(ArrowRightIcon, {
          height: "24px",
          width: "24px"
        })]
      })
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { QuickLink };
//# sourceMappingURL=QuickLink.js.map
